export default "__VITE_ASSET__D08PcRUn__"